$(document).ready(function() {
	if(!document.getElementById('modal_find_my_model') && !document.getElementById('modal_find_my_model_qrcode')) return false; // LGEGMC-3937
	
	// #### modal : Find my Model category scripts
	var mainselect = document.getElementById('mainCategorySelect_fmm');
	var superselect = document.getElementById('superCategorySelect_fmm');
	var subselect = document.getElementById('subCategorySelect_fmm');

	// LGEGMC-3937 Start
	const mainselect2 = document.getElementById('mainCategorySelect_fmm2');
	var superselect2 = document.getElementById('superCategorySelect_fmm2'); // LGEGMC-4170
	const subselect2 = document.getElementById('subCategorySelect_fmm2');
	const scanQRcodeFlag = $('#scanQRcodeFlag').val() === 'Y' ? true : false;
	// LGEGMC-3937 End

	var modal = {
		el: scanQRcodeFlag ? document.getElementById("modal_find_my_model_qrcode") : document.getElementById("modal_find_my_model"), // LGEGMC-3937
		form: document.getElementById("findMyModelForm"),
		form2: document.getElementById("findMyModelForm2"), // LGEGMC-3937
		submit: document.getElementById("findMyModelSubmit"),
		// LGEGMC-3937 Start
		init: function(){
			if(scanQRcodeFlag) modal.defaultEvent().then(modal.qrEvent);
			else modal.addEvent();
		},
		defaultEvent: function(){
			return new Promise(function(resolve){
				modal.addEvent();
				resolve();
			});
		},
		qrEvent: function(){
			modal.addEvent('qr');
		},
		addEvent: function(type){
			const typeQR = type === 'qr' ? true : false;
			const mainselectSwitch = typeQR ? mainselect2 : mainselect;
			const superselectSwitch = typeQR ? superselect2 : superselect; // LGEGMC-4170
			const subselectSwitch = typeQR ? subselect2 : subselect;
			const formSwitch = typeQR ? modal.form2 : modal.form;
			const $formPanal = $(formSwitch).closest('.modal-form-area').parent();

			$(modal.el).on({
				'show.bs.modal': function(e){
					adobeTrackEvent('find_my_model', {page_event : {find_my_model : true}});
					if(superselectSwitch){
						$(mainselectSwitch).drawAjaxOptions({
							setTarget: superselectSwitch // LGEGMC-4170
						});
						$(superselectSwitch).drawAjaxOptions({
							setTarget: subselectSwitch
						});
					}else if(subselectSwitch){
						$(mainselectSwitch).drawAjaxOptions({
							setTarget: subselectSwitch
						});
					}
				},
				/* LGEPA-220 : 20210120 add */
				'hidden.bs.modal' : function(e){
					if($(modal.el).find('.modal-zoom').hasClass('active')){
						$(modal.el).find('.modal-dialog').removeClass('zoom-active');
						$(modal.el).find('.modal-zoom').removeClass('active').attr('tabindex','-1').focus();
					}
				}
				/*// LGEPA-220 : 20210120 add */
			});
			$(formSwitch).on({
				submit: function(e){
					e.preventDefault();

					var param = $(this).serializeArray();
					var url = this.getAttribute('data-url');
					// var data = ajax.call(url, param, 'html');
					ajax.call(url, param, 'html', function(data){
						$formPanal.find('.find-model-results').addClass('active').html(data).find('style').remove();
						$formPanal.find('.find-model-default').removeClass('active');
						$(modal.el).modalUpdate();
						
						/* LGEPA-220 : 20210120 add */
						if(!!$(modal.el).find('.modal-zoom').length){
							var imgSrc = $formPanal.find('.find-model-results').find('.find-img img').attr('src');
							var imgAlt = $formPanal.find('.find-model-results').find('.find-img img').attr('alt');
							$(modal.el).find('.zoom-area img').attr('src', imgSrc).attr('alt', imgAlt);
							
							$.getScript("/lg5-common-gp/library/panzoom.min.js", function(){
								modal.zoom.init();
							});
						}						
						/*// LGEPA-220 : 20210120 add */
					});
				}
			});
			$(mainselectSwitch).on({
				'change.base': function(){
					$formPanal.find('.find-model-results').removeClass('active');
					$formPanal.find('.find-model-default').addClass('active');

					if(superselectSwitch){
						$(subselectSwitch).attr("disabled", "disabled").find("option:not(:first-child)").remove();
						$(subselectSwitch).trigger("chosen:updated");
					}
				}
			});
			if(superselectSwitch){
				$(superselectSwitch).on({
					'change.base': function(){
						$formPanal.find('.find-model-results').removeClass('active');
						$formPanal.find('.find-model-default').addClass('active');
					}
				});
			}
			$(subselectSwitch).on({
				'change.sub': function(){
					$(formSwitch).submit();
				}
			});
			
			/* LGEPA-220 : 20210120 add */
			$(modal.el).on({
				'click.find-img': function(e){
					e.preventDefault();
					e.preventDefault();
					$(modal.el).find('.modal-dialog').addClass('zoom-active');
					$(modal.el).find('.modal-zoom').addClass('active').attr('tabindex','0').focus();
				}
			}, 'a.find-img');
			$(modal.el).on({
				'click.zoom-close': function(e){
					$(modal.el).find('.modal-dialog').removeClass('zoom-active');
					$(modal.el).find('.modal-zoom').removeClass('active');
					$(modal.el).attr('tabindex','-1');
					$(modal.el).find('.find-img').focus();
				}
			}, '.zoom-close');
			/*// LGEPA-220 : 20210120 add */
		},
		// LGEGMC-3937 End
		/* LGEPA-220 : 20210120 add */
		zoom: {
			_opt : {
				option : {
					transition: true,
					cursor: 'inherit',
					disablePan: false,
					disableZoom: false,
					disableXAxis: false,
					disableYAxis: false,
					which: 1,
					increment: 0.2,
					linearZoom: false,
					panOnlyWhenZoomed: true,
					minScale: 1,
					maxScale: 2,
					rangeStep: 0.05,
					duration: 200,
					contain: false,
					onPan: function(){
						$(this).addClass('dragged');
					},
					onZoom: function(){
						var $n = $(this);
						var matrix = $n.panzoom("getMatrix");
						if(matrix[0] <= "1.1") {
							if(matrix[4] != 0 && matrix[5] != 0){
								$n.panzoom("reset");
							}
						}
					}
				}
			},
			init: function(){
				var _this = modal;
				var _zoom = this;
				var zoomImg = _this.el.querySelectorAll('.zoom-area img');

				if(!_this.el.getAttribute('data-zoom-event')){
					_this.el.setAttribute('data-zoom-event', true);
					_zoom.addEvent();
				}
				
			},
			zoomin: function($target, opt, max){
				$target.panzoom("zoom", false, {
					increment: max ? opt.maxScale : opt.increment,
					animate: true
				});
				if(opt.maxScale == $target.panzoom("getMatrix")[0]){
					$target.parent('.zoom-area').addClass('zoomout');
				}else {
					$target.parent('.zoom-area').removeClass('zoomout');
				}
			},
			zoominpos: function(e,$target, opt, max){
				$target.panzoom("zoom", false, {
					increment: max ? opt.maxScale : opt.increment,
					animate: true,
					focal:e
				});
				if(opt.maxScale == $target.panzoom("getMatrix")[0]){
					$target.parent('.zoom-area').addClass('zoomout');
				}else {
					$target.parent('.zoom-area').removeClass('zoomout');
				}
			},
			zoomout: function($target, opt){
				if($target.panzoom("getMatrix")[0] <= (1+opt.increment)) {
					$target.panzoom("reset");
				}else {
					$target.panzoom("zoom", true, {
						increment: opt.increment,
						animate: true
					});
				}
				$target.parent('.zoom-area').removeClass('zoomout');
			},
			clickAction: function(e){
				var _this = modal,
					_zoom = _this.zoom,
					currentTarget = e.currentTarget ? e.currentTarget : e.target,
					$target = $(currentTarget),
					opt;

				$target.panzoom(_zoom._opt.option);
				opt = $target.panzoom("option");

				if(!$target.is('.dragged')) {
					var $area = $target.parent('.zoom-area');
					if(!$area.is('.zoomout')) {
						if(e.type == 'doubletap') {
							_zoom.zoominpos(e,$target, opt, true); // maximum zoomin
						}else {
							_zoom.zoominpos(e,$target, opt);
						}
					}else {
						$target.panzoom('reset');
						$area.removeClass('zoomout');
					}
				}

				$target.removeClass('dragged');
			},
			addEvent: function(){
				var _this = modal,
					_zoom = this;
				$(_this.el).on({
					'click.panzoom': function(e){
						var $target = $(_this.el).find('.zoom-area img');
						var opt;
						var $btn = $(e.currentTarget);

						$target.panzoom(_zoom._opt.option);
						opt = $target.panzoom("option");

						if($btn.is('.plus')){
							_zoom.zoomin($target, opt);
						}else if($btn.is('.minus')){
							_zoom.zoomout($target, opt);
						}
					}
				}, '.control button');

				if ('ontouchstart' in window){
					// in touch device
					var $target = $(_this.el).find('.zoom-area img');
					for (var i = 0; i < $target.length; i++) {
						var _target = $target.eq(i)[0];
						var hammer = new Hammer(_target).on('doubletap', _zoom.clickAction);
					}
				}else {
					$(_this.el).on({
						click: _zoom.clickAction,
						wheel: function(e){
							var $target = $(e.currentTarget);
							$target.panzoom(_zoom._opt.option);
							opt = $target.panzoom("option");
							if(e.originalEvent.deltaY < 0) {
								// zoom in
								_zoom.zoomin($target, opt);
							}else {
								// zoom out
								_zoom.zoomout($target, opt);
							}
						}
					}, '.zoom-area img');
				}
			}
		}
		/*// LGEPA-220 : 20210120 add */
	};
	modal.init();

	$('body').on('click.seemore', '.search-area .search-layer .search-footer-area a.link-more', function(e) {
		e.preventDefault();
		var url = $(this).attr('href');
		var searchTxt = $(this).closest('form').find('.search-input input').val();
		$form = $("<form />", {id: 'tmpForm', action:url, method: 'post'});
		$form.append('<input type="hidden" name="search" value="'+xssfilter(searchTxt)+'">');
		$('body').append($form);
		$("#tmpForm").submit();
	});
});